<div class="cr-canvas-wrap" #canvasWrap (dragover)="onCanvasFileDrag($event)" (drop)="onCanvasFileDrag($event)">
  <div class="cr-canvas" [class.mobile]="deviceMode === 'mobile'" [class.cr-view-mode]="isReadonlyMode" [class.cr-review-mode]="reviewMode !== 'off'" [class.cr-annotate-mode]="reviewMode === 'annotate'" (click)="onCanvasLinkClick($event)" (auxclick)="onCanvasLinkClick($event)">
    <div class="cr-review-empty-canvas" *ngIf="showReviewEmpty">
      <span class="cr-review-empty-canvas-icon" aria-hidden="true"><svg viewBox="0 0 32 32" focusable="false"><path d="M7.5 6.5h17a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-7l-4.6 4v-4H7.5a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2Z"></path></svg></span>
      <strong>Nothing in review yet</strong>
      <span>Press <b>Pull current version</b> in the Comments panel to bring the current {{ languageLabel }} content in. Editing keeps running on the live content.</span>
      <button type="button" class="cr-btn cr-btn-primary" (click)="pullVersion.emit()">+ Pull current version</button>
    </div>

    <ng-container *ngIf="!showReviewEmpty">
      <div class="cr-system-fields" *ngIf="subjectBlock || preheaderBlock">
        <div
          class="cr-system-field"
          [class.active]="selectedBlockId === subjectBlock.blockId"
          [attr.data-block-id]="subjectBlock.blockId"
          *ngIf="subjectBlock"
        >
          <app-subject-v2 [block]="subjectBlock" [isPreview]="true" (blockData)="blockDataChange.emit($event)"></app-subject-v2>
          <app-annotation-layer-v2 [blockId]="subjectBlock.blockId"></app-annotation-layer-v2>
        </div>
        <div
          class="cr-system-field"
          [class.active]="selectedBlockId === preheaderBlock.blockId"
          [attr.data-block-id]="preheaderBlock.blockId"
          *ngIf="preheaderBlock"
        >
          <app-preheader-v2 [block]="preheaderBlock" [isPreview]="true" (blockData)="blockDataChange.emit($event)"></app-preheader-v2>
          <app-annotation-layer-v2 [blockId]="preheaderBlock.blockId"></app-annotation-layer-v2>
        </div>
      </div>

      <ng-container *ngIf="showAddBlock && !isReadonlyMode">
        <app-add-block-v2
          [addBlockDisabled]="addBlockDisabled"
          [blockData]="allBlocks[1]"
          (openAddBlock)="onOpenAddBlock($event)"
        ></app-add-block-v2>
      </ng-container>

      <ng-container *ngFor="let block of blocks">
        <div
          class="cr-preview-block"
          role="button"
          tabindex="0"
          [attr.data-block-id]="block.blockId"
          [style.margin-top.px]="isReadonlyMode ? gapBeforeReadonly(block) : null"
          (click)="onBlockActivate($event, block.blockId)"
          (keydown.enter)="onBlockActivate($event, block.blockId)"
          (keydown.space)="onBlockActivate($event, block.blockId)"
        >
          <app-block-renderer-v2
            [block]="block"
            [isPreview]="true"
            [deviceMode]="deviceMode"
            (blockData)="blockDataChange.emit($event)"
          ></app-block-renderer-v2>
          <app-annotation-layer-v2 [blockId]="block.blockId"></app-annotation-layer-v2>
        </div>

        <app-add-block-v2
          *ngIf="showAddBlock && !isReadonlyMode"
          [addBlockDisabled]="addBlockDisabled"
          [blockData]="block"
          [nextBlock]="nextRealBlock(block)"
          [gapSize]="gapSizeAfter(block)"
          (openAddBlock)="onOpenAddBlock($event)"
          (gapSizeChange)="onGapSizeChange(block, $event)"
        ></app-add-block-v2>
      </ng-container>

      <div class="cr-canvas-empty" *ngIf="blocks.length === 0 && reviewMode === 'off'">
        No blocks yet — use the + button to add your first block.
      </div>
    </ng-container>
  </div>
</div>

<!-- Sibling to cr-canvas-wrap (not nested inside it) so its overflow:auto
     scrolling never clips the modal, which stays fixed at the same spot. -->
<app-add-block-modal-v2
  *ngIf="addBlockModalContext"
  [blockData]="addBlockModalContext"
  [selectedBlocks]="allBlocks"
  [blockSelect]="blockSelect"
  (closeModal)="addBlockModalContext = null"
  (blockSelectEvent)="onAddBlockSelected($event)"
></app-add-block-modal-v2>
